import { Button, Image, Modal } from "react-bootstrap";

import styles from "./brandkit.components.module.scss";

function DeleteModal({
  showDeleteModal,
  centered,
  size,
  cancelHandler,
  handleDeleteClick,
  isDeleting,
  backdrop,
  title,
  message,
}) {
  return (
    <Modal
      className={styles.deleteBrandkitModal}
      contentClassName={styles.deleteBrandkitModalContent}
      dialogClassName={styles.deleteBrandkitModalDialog}
      backdropClassName={styles.backdropWrapper}
      backdrop={backdrop} 
      show={showDeleteModal}
      centered={centered || true}
      size={size || "lg"}
      onClick={(e) => {
        e.stopPropagation();
      }}
      style={{ background: "rgb(0 0 0 / 75%)" }}
    >
      <Modal.Body style={{ padding: "0px" }}>
        <div className={styles.deleteBrandkitModalContainer}>
          <div className={styles.deleteBrandkitModalHeaderContainer}>
            <h2>{title}</h2>
            <Button
              variant="secondary"
              className={styles.btnIconsWrap}
              onClick={cancelHandler}
              disabled={isDeleting}
            >
              <i className={"cleverstory-close"} />
            </Button>
          </div>
          <div className={styles.messageContainer}>
            <Image src={"/images/deleteTemplate.png"} height={"50px"} />
            <p>{message}</p>
          </div>
          <div className={styles.deleteBrandkitModalButtons}>
            <Button variant="secondary" onClick={cancelHandler}
            className={styles.deleteCancelModalBtn}
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleDeleteClick}
            className={styles.deleteModalBtn}
            disabled={isDeleting}
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteModal;